import { TextButton, type TextButtonProps } from "../../components/TextButton";

interface DocumentStatusCardActionButtonProps extends Omit<
  TextButtonProps,
  "children" | "withRightArrow" | "underline" | "size"
> {
  children?: string;
  withRightArrow?: boolean;
  underline?: boolean;
}

export function DocumentStatusCardActionButton(props: DocumentStatusCardActionButtonProps) {
  const { children = "View document", ...restProps } = props;

  return (
    <TextButton withRightArrow underline={false} size="large" {...restProps}>
      {children}
    </TextButton>
  );
}
